export default __webpack_public_path__ + "static/media/calenderIcon.c5bcec2f.svg";